module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"arrowKeys":"Navegar","enterKey":"Abrir"},"en":{"arrowKeys":"Select","enterKey":"Open"}}')
  delete Component.options._Ctor
}
